attachEvent('.product-card__thumbnail:not(.is-out-of-stock)', 'click', (e) => {
  const thumbnail = e.target.closest('.product-card__thumbnail');
  if (!thumbnail) return;

  const card = thumbnail.closest('.product-card');
  const thumbnails = [...card.querySelectorAll('.product-card__thumbnail')];
  const i = thumbnails.indexOf(thumbnail);

  card
    .querySelectorAll('.product-card__slide, .product-card__thumbnail')
    .forEach((el) => el.classList.remove('is-active'));

  card.querySelectorAll('.product-card__slide')[i]?.classList.add('is-active');
  thumbnail.classList.add('is-active');

  const { link, title, text, price, priceSlashed, discount } = thumbnail.dataset;

  if (link) {
    const linkEl = card.querySelector('.stretched-link');
    if (linkEl) {
      linkEl.href = link;
      if (title) linkEl.setAttribute('aria-label', title);
    }
  }

  if (title) {
    const titleEl = card.querySelector('.product-card__title');
    if (titleEl) titleEl.textContent = title;
  }

  if (text) {
    const textEl = card.querySelector('.product-card__text');
    if (textEl) textEl.textContent = text;
  }

  if (price) {
    const priceEl = card.querySelector('.product-card__price');
    if (priceEl) priceEl.textContent = price;
  }

  const slashedEl = card.querySelector('.product-card__price-slashed');
  if (slashedEl) {
    if (priceSlashed) {
      slashedEl.style.display = '';
      const s = slashedEl.querySelector('s');
      if (s) s.textContent = priceSlashed;
    } else {
      slashedEl.style.display = 'none';
    }
  }

  const discountEl = card.querySelector('.product-card__footer-bottom .tag.blue');
  if (discountEl) {
    if (discount) {
      discountEl.style.display = '';
      discountEl.textContent = discount;
    } else {
      discountEl.style.display = 'none';
    }
  }
});

let wishlistRequestQueue = Promise.resolve();
let pendingWishlistMutations = 0;

attachEvent('.product-card__wishlist', 'click', async (ev) => {
  ev.preventDefault();
  ev.stopPropagation();

  const btn = ev.target.closest('.product-card__wishlist');
  if (!btn) return;

  const { productId } = btn.dataset;
  if (!productId) return;

  // Fractal preview: no network call, just toggle
  if (typeof localData === 'undefined' || !localData?.apiURL) {
    btn.classList.toggle('is-active');
    return;
  }

  const wasActive = btn.classList.contains('is-active');
  const isActive = !wasActive;
  const isWishlistPage =
    document.querySelector('main.page-wishlist') || btn.closest('[data-component="mol-profile-wishlist"]');
  const wrapper =
    !isActive && isWishlistPage
      ? btn.closest('.swiper-slide') || btn.closest('.product-list__list-item') || btn.closest('.product-card')
      : null;
  const wrapperParent = wrapper?.parentNode;
  const wrapperPlaceholder = wrapper ? document.createComment('wishlist-card') : null;
  const slider = wrapper?.closest('.swiper')?.swiper;
  const getWishlistCount = () => Number(document.querySelector('[data-wishlist-count]')?.textContent);
  const updateWishlistCount = (count) => {
    document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  };
  const adjustWishlistCount = (amount) => {
    const count = getWishlistCount();
    if (!Number.isNaN(count)) {
      updateWishlistCount(Math.max(0, count + amount));
    }
  };
  const restoreCard = () => {
    if (wrapper && wrapperParent && wrapperPlaceholder?.parentNode === wrapperParent) {
      wrapperPlaceholder.replaceWith(wrapper);
      slider?.update();
    }
  };

  btn.classList.toggle('is-active', isActive);
  adjustWishlistCount(isActive ? 1 : -1);
  if (wrapper) {
    wrapper.replaceWith(wrapperPlaceholder);
    slider?.update();
  }

  btn.disabled = true;
  pendingWishlistMutations += 1;

  wishlistRequestQueue = wishlistRequestQueue
    .then(async () => {
      try {
        const nonce = await getNonceForAction('toggleItemOnLikedList');
        const formData = new FormData();
        formData.append('action', 'toggleItemOnLikedList');
        formData.append('productid', productId);
        formData.append('nonce', nonce);
        formData.append('lang', localData.lang);

        const { data } = await axios.post(localData.apiURL, formData);

        if (data.success) {
          const { count, active } = data.data;
          const isServerActive = active === true || active === 1 || active === '1';

          btn.classList.toggle('is-active', isServerActive);
          if (isServerActive && data.data.add_to_wishlist) {
            pushEcommerceEvent('add_to_wishlist', data.data.add_to_wishlist);
          }
          if (pendingWishlistMutations === 1) {
            updateWishlistCount(count);
          }
          if (isServerActive) {
            restoreCard();
          } else {
            wrapperPlaceholder?.remove();
          }
        } else {
          btn.classList.toggle('is-active', wasActive);
          adjustWishlistCount(isActive ? -1 : 1);
          restoreCard();
        }
      } catch (error) {
        btn.classList.toggle('is-active', wasActive);
        adjustWishlistCount(isActive ? -1 : 1);
        restoreCard();
        console.error('Wishlist toggle error:', error);
      } finally {
        pendingWishlistMutations -= 1;
        btn.disabled = false;
      }
    })
    .catch((error) => {
      console.error('Wishlist queue error:', error);
    });

  await wishlistRequestQueue;
});
